var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.3C11.1 -0.9 6.3 -0.2 3.1 2.8V1C3.1 0.4 2.7 0 2.1 0C1.5 0 1.1 0.4 1.1 1V5.5C1.1 6.1 1.5 6.5 2.1 6.5H6.6C7.2 6.5 7.6 6.1 7.6 5.5C7.6 4.9 7.2 4.5 6.6 4.5H4.2C5.7 2.9 7.8 2 10 2C14.4 2 18 5.6 18 10C18 14.4 14.4 18 10 18C5.6 18 2 14.4 2 10C2 9.4 1.6 9 1 9C0.4 9 0 9.4 0 10C0 15.5 4.5 20 10 20C13.6 20 16.9 18.1 18.7 15C21.4 10.2 19.8 4.1 15 1.3ZM10 6C9.4 6 9 6.4 9 7V10C9 10.6 9.4 11 10 11H12C12.6 11 13 10.6 13 10C13 9.4 12.6 9 12 9H11V7C11 6.4 10.6 6 10 6Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.ab7ffcc364c64486f956b6ee6c3ec41a.svg";
export { ForwardRef as ReactComponent };